<template>
  <div class="yht-title">
    <p class="yht-title_name" v-text="titleName"></p>
  </div>
</template>

<script>

export default {
  name: 'title',
  data () {
    return {

    }
  },
  props: {
    titleName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  .yht-title {
    position: relative;
    padding-top: 15px;
    width: 100%;
  }

  .yht-title_name {
    position: relative;
    margin: 0 auto;
    padding-top: 45px;
    width: 252px;
    height: 75px;
    font-size: 20px;
    font-weight: 600;
    text-align: center;
    color: #6B523D;
    background: url("../../assets/images/build.png") no-repeat;
    background-size: 100% 100%;
  }

  .yht-title::before,
  .yht-title::after {
    content: '';
    position: absolute;
    top: 70px;
    width: 437px;
    height: 1px;
    border: 1px solid #6B523D;
  }

  .yht-title::before {
    left: 0;
  }

  .yht-title::after {
    right: 0;
  }
</style>
